import React from 'react';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';

interface IProps {
  notes: string;
}

export const OrderNotes: React.FC<IProps> = ({ notes }) => {
  return (
    <div className="details-notes">
      <p className="details-notes-title">{localeStore.t('order_notes')}</p>
      <p className="details-notes-text">{notes}</p>
    </div>
  );
};
